import React, { useState } from "react";

const SupportForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    uid: "",
    problemType: "",
    problemDetails: "",
  });

  const isFormValid = Object.values(formData).every((value) => value.trim() !== "");

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isFormValid) {
      alert("Form submitted successfully!");
      // Perform the form submission logic here
    }
  };

  return (
    <div className="min-h-screen sidebar-bg-responsive flex items-center justify-center paddingX">
      <div className="bg-white shadow-lg rounded-lg p-6 max-w-md w-full">
        <div className="text-center mb-4 flex justify-center items-center text-2xl font-black">
          Help & Support
        </div>
        <form onSubmit={handleSubmit}>
          {/* Name Field */}
          <div className="mb-4">
            <label htmlFor="name" className="block text-gray-700 font-semibold mb-1">
              Name:
            </label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              className="w-full border border-gray-300 rounded-lg p-2 focus:outline-none"
              placeholder="Enter your name"
              required
            />
          </div>

          {/* Email Field */}
          <div className="mb-4">
            <label htmlFor="email" className="block text-gray-700 font-semibold mb-1">
              Email:
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              className="w-full border border-gray-300 rounded-lg p-2 focus:outline-none"
              placeholder="Enter your email"
              required
            />
          </div>

          {/* UID Field */}
          <div className="mb-4">
            <label htmlFor="uid" className="block text-gray-700 font-semibold mb-1">
              UID Number:
            </label>
            <input
              type="text"
              id="uid"
              name="uid"
              value={formData.uid}
              onChange={handleInputChange}
              className="w-full border border-gray-300 rounded-lg p-2 focus:outline-none"
              placeholder="Enter your UID number"
              required
            />
          </div>

          {/* Problem Type Field */}
          <div className="mb-4">
            <label htmlFor="problemType" className="block text-gray-700 font-semibold mb-1">
              Problem Type:
            </label>
            <select
              id="problemType"
              name="problemType"
              value={formData.problemType}
              onChange={handleInputChange}
              className="w-full border border-gray-300 rounded-lg p-2 focus:outline-none"
              required
            >
              <option value="" disabled>
                Please select a problem type
              </option>
              <option value="Account login Issue">Account login Issue</option>
              <option value="Withdrawal Problem">Withdrawal Problem</option>
              <option value="Deposit Problem">Deposit Problem</option>
              <option value="Others Problem">Others Problem</option>
            </select>
          </div>

          {/* Problem Details Field */}
          <div className="mb-6">
            <label htmlFor="problemDetails" className="block text-gray-700 font-semibold mb-1">
              Problem Details:
            </label>
            <textarea
              id="problemDetails"
              name="problemDetails"
              value={formData.problemDetails}
              onChange={handleInputChange}
              className="w-full border border-gray-300 rounded-lg p-2 focus:outline-none"
              placeholder="Provide details about your problem"
              rows="4"
              required
            />
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            disabled={!isFormValid}
            className={`w-full p-2 rounded-lg text-white font-semibold ${isFormValid ? "bg-purple-500 hover:bg-purple-600" : "bg-gray-300 cursor-not-allowed"
              }`}
          >
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default SupportForm;
